module.exports = __webpack_public_path__ + "static/media/doctor-avatar-1.f76bba52.svg";